<template>
    <Widget title="Dice Roller" :minWidth="200" :minHeight="200" :maxWidth="300" :maxHeight="600">
        <RollLog />
        <DiceRoller />
        <br />
        <a href="https://skizzerz.net/DiceRoller/Dice_Reference">Dice Formula How To</a>
    </Widget>
</template>

<script lang="ts">
import Widget from '@/components/common/widget/Widget.vue';
import DiceRoller from './DiceRoller.vue';
import RollLog from './RollLog.vue';

export default {
    components: {
        DiceRoller: DiceRoller,
        RollLog: RollLog,
        Widget: Widget,
    },
    data() {
        return {
            isOpen: '',
        };
    },
};
</script>
